import { Card } from '@heidi/design-system/card';
import { cn } from '@heidi/utils';
import { forwardRef, memo } from 'react';
import {
  HASH_HIGHLIGHT_CLASSES,
  settingsSectionCardClasses,
} from './section-card.styles';
import type { SettingsSectionCardProps } from './section-card.types';

export const SettingsSectionCard = memo(
  forwardRef<HTMLDivElement, SettingsSectionCardProps>(
    ({ children, className, id, highlighted, 'data-testid': testId }, ref) => {
      return (
        <Card
          className={cn(
            settingsSectionCardClasses,
            highlighted && HASH_HIGHLIGHT_CLASSES,
            className
          )}
          data-testid={testId}
          id={id}
          ref={ref}
        >
          {children}
        </Card>
      );
    }
  )
);

SettingsSectionCard.displayName = 'SettingsSectionCard';

export { HASH_HIGHLIGHT_CLASSES };
